import { type FC } from 'react';

import MultiViewCampaign from './views/MultiViewCampaign';
import SingleViewCampaignWrapper from './views/SingleViewCampaign';
import type { ICampaignMultiViewSectionProps, ICampaignSingleViewSectionProps } from 'features/campaigns';
import { CampaignTypeProvider, SECTION_TO_CAMPAIGN_TYPE, useCampaignEnabledMap } from 'features/campaigns';

// The gate hook itself lives in hooks/useCampaignSectionGate so that callers
// outside this feature can subscribe to campaign visibility without pulling
// the whole campaign component tree in through the barrel.
export { SECTION_TO_CAMPAIGN_TYPE, useCampaignEnabledMap, useCampaignSectionGate } from '../hooks/useCampaignSectionGate';

export const CampaignMultiViewSection: FC<ICampaignMultiViewSectionProps> = ({ data, isActive }) => {
  const enabledMap = useCampaignEnabledMap();
  const campaignType = SECTION_TO_CAMPAIGN_TYPE[data.name];
  if (!campaignType || !enabledMap[campaignType]) return null;
  return <CampaignTypeProvider type={campaignType}><MultiViewCampaign data={data} isActive={isActive} /></CampaignTypeProvider>;
};

export const CampaignSingleViewSection: FC<ICampaignSingleViewSectionProps> = ({ sectionName }) => {
  const enabledMap = useCampaignEnabledMap();
  const campaignType = SECTION_TO_CAMPAIGN_TYPE[sectionName];
  if (!campaignType || !enabledMap[campaignType]) return null;
  return <CampaignTypeProvider type={campaignType}><SingleViewCampaignWrapper key={campaignType} campaignType={campaignType} /></CampaignTypeProvider>;
};
